module.exports = {
    REGULAR_SCHEDULE_GET: 'REGULAR_SCHEDULE_GET',
};
